<template>
  <div class="block">
    <!-- <div class="header">
      <img src="@/assets/icon_back.png" @click="routerback">
      <span>{{ title }}</span>
      <span></span>
    </div> -->
    <div v-infinite-scroll="loadMore"
      :infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
      style="flex: 1;overflow-y: auto;">
      <templet-factory
        :list="list"
        :template="template"
      />
      <!-- <threecolumn-row v-if="template == 'threecolumn-row'" :list="list" ></threecolumn-row>
      <line-column v-else-if="template == 'line-column'" :list="list" ></line-column>
      <twocolumn-row v-else :list="list" ></twocolumn-row> -->
    </div>
  </div>
</template>
<script>
// import TwocolumnRow from '@/components/TwocolumnRow'
// import ThreecolumnRow from '@/components/ThreecolumnRow'
// import LineColumn from '@/components/LineColumn'
import TempletFactory from '@/components/TempletFactory'

import { InfiniteScroll } from 'mint-ui'
import { moreInfo } from '@/api/more'
import { setTitle } from '@/api/app'
import { umtrack } from '@/utils/uweb'
export default {
  name: 'more',
  components: {
    // TwocolumnRow,
    // ThreecolumnRow,
    // LineColumn,
    TempletFactory,
    // eslint-disable-next-line vue/no-unused-components
    InfiniteScroll
    
  },
  props: {
    options: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  created () {
    var query = this.$route.query
    this.id = query.id
    this.template = query.template
    this.title = query.title
    umtrack('blockView', {id: this.id, title: this.title}, this)
  },
  mounted() {
    setTitle(this.title);
  },
  data () {
    return {
      id: 0,
      template: '',
      title: '',
      loading: true,
      pageinfo: {
        current_page: 0
      },
      list: []
    }
  },
  methods: {
    loadMore: function () {
      if(this.pageinfo.current_page > 0 && this.pageinfo.current_page == this.pageinfo.last_page){
        return
      }
      this.loading = true;
      moreInfo({id: this.id, page: (this.pageinfo.current_page + 1)}).then(response => {
        var data = response.data.data
        this.pageinfo = {
          current_page: data.current_page,
          last_page: data.last_page
        }
        this.list = this.list.concat(data.data)
        this.loading = false;
      })
    },
    routerback: function () {
      this.$router.back(-1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.block {
  height: 100vh;

  display: flex;
  flex-direction: column;
}
.block .header{
  font-size: 19px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 13px 16px;
}
</style>
